import { useEffect, useState } from "react";
import { useLocation, } from "react-router-dom";
import { Card, CardFooter, CardHeader, Container, Row, Table, Input } from "reactstrap";
import TablePagination from "views/components/TablePagination";
import { filterItems, formatDateTime } from "lib/helper";
import ExportButton from "components/ExportButton";
import FormsModel from "models/forms.model";
import { helper } from "lib/helper";
import TableHeader from "components/TableHeader/TableHeader";

const Listing = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);

  const [searchQuery, setSearchQuery] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const location = useLocation();



  const getListData = async () => {
    setIsLoading(true);
    try {
      const result = await FormsModel.investor_relation();
      if (result) { setDataList(result?.data?.data); }
    } catch (error) {
      helper.sweetalert.toast(error.response?.data?.message, "warning");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { getListData(); }, [location]);
  useEffect(() => { setCurrentPage(1); }, [searchQuery, fromDate, toDate]);

  const dateFilteredList = dataList.filter((item) => {
    const createdAt = new Date(item.createdAt);
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;
    return (!from || createdAt >= from) && (!to || createdAt <= to);
  });

  const filteredDataList = filterItems(
    dateFilteredList.map((e) => ({ ...e.hostedBy, ...e })),
    searchQuery,
    ["Name", "Organization", "Message", "Added On"]
  );
  const startIndex = (currentPage - 1) * perPage;
  const paginatedDataList = filteredDataList.slice(startIndex, startIndex + perPage);

  const handlePageChange = (pageNumber) => { setCurrentPage(pageNumber); };

  const columnsConfig = [
    {
      label: "S.No",
      getValue: (_, index) => startIndex + index + 1
    },
    {
      label: "Name",
      getValue: (item) => `${item?.full_name} ${item?.email} (${item?.contact_no})`,
    },
    {
      label: "Organization",
      getValue: (item) => item?.organization
    },
    {
      label: "Message",
      getValue: (item) => item?.message
    },
  ];


  return (
    <Container className="pt-7" fluid>
      {!isLoading && (
        <Row>
          <div className="col pl-0 pr-0">
            <Card className="shadow">
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Investor relation</h3>
                <div className="d-flex align-items-center">
                  <div>
                    <lebal className="text-sm">Search</lebal>
                    <Input
                      type="text"
                      placeholder="Search Here..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{ width: "200px", marginRight: "10px" }}
                    />
                  </div>
                  {/* <div>
                    <lebal className="text-sm">To date</lebal>
                    <Input
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      style={{ marginRight: "10px" }}
                    />
                  </div>
                  <div className="ml-2">
                    <lebal className="">Form date</lebal>
                    <Input
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      style={{ marginRight: "10px" }}
                    />
                  </div> */}
                  <div className=" ml-3 mt-4">
                    <ExportButton data={filteredDataList} columnsConfig={columnsConfig} />
                  </div>
                </div>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <TableHeader options={[
                  "#",
                  "Name",
                  "Organization",
                  "Message",
                  "Added On"
                ]} />
                <tbody>
                  {paginatedDataList.map((item, index) => (
                    <tr key={item._id}>
                      <td>{startIndex + index + 1}</td>
                      <td>
                        <div className="fw-semibold">{item?.full_name}</div>
                        <div className="text-muted small">
                          {item?.email}
                          {item?.contact_no ? ` • ${item.contact_no}` : ""}
                        </div>
                      </td>
                      <td>{item?.organization}</td>
                      <td>{item?.message}</td>
                      <td>{formatDateTime(item?.createdAt)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <TablePagination
                  totalPages={Math.ceil(filteredDataList.length / perPage)}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
      )}
    </Container>


  );
};

export default Listing;
